import { render, staticRenderFns } from "./ToplamERPSiparisSayisi.vue?vue&type=template&id=7176151a&scoped=true"
import script from "./ToplamERPSiparisSayisi.vue?vue&type=script&lang=js"
export * from "./ToplamERPSiparisSayisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176151a",
  null
  
)

export default component.exports